import React, { Fragment } from 'react'

import "../../../assets/css/scss/section/player/_infoContentHoriz.scss";
import GetActiveLcdData from '../../../common/getActiveLcdData';
import { IReduxStateData } from '../../../interfaces/redux';
import { useSelector } from 'react-redux';

export default function InfoContentHoriz(props: any) {
    const disData = props?.data?.infoHorizData;
    const globalState = useSelector((state: IReduxStateData) => state);
    let globalStateData: any = GetActiveLcdData(globalState);
    console.log("leaguge >", globalStateData)
    return (
        <Fragment>
            {disData?.isDisplay ?
                <div className="info-content-horiz">
                    <div className="profile-title theme-dark-gray">
                        <h3 className="bold h4 theme-green mb-0">{globalStateData?.league_name ? globalStateData?.league_name.toUpperCase() : "League"} Status</h3>
                    </div>
                    <div className="profile-detail theme-gray">
                        <div className="d-flex align-items-center justify-content-between">
                            {disData?.data.map((item: any) =>
                                <div>
                                    <h4 className="font-semibold h6 mb-3">{item?.title}</h4>
                                    <h5 className="font-bold h4 mb-3">{item?.value || "-"}</h5>
                                    {item?.rankTitle ? <h6 className="font-light font-16">{item?.rankTitle}{item?.rankSup ? <sup>{item?.rankSup}</sup> : null}</h6> : null}
                                </div>
                            )}
                            {/* <div>
                                <h4 className="font-semibold h6 mb-3">HR</h4>
                                <h5 className="font-bold h4 mb-3">29</h5>
                                <h6 className="font-light font-16">Tied-44<sup>th</sup></h6>
                            </div>
                            <div>
                                <h4 className="font-semibold h6 mb-3">RBI</h4>
                                <h5 className="font-bold h4 mb-3">95</h5>
                                <h6 className="font-light font-16">31<sup>st</sup></h6>
                            </div>
                            <div>
                                <h4 className="font-semibold h6 mb-3">OPS</h4>
                                <h5 className="font-bold h4 mb-3">.999</h5>
                                <h6 className="font-light font-16">3<sup>rd</sup></h6>
                            </div> */}
                        </div>
                    </div>
                </div>
                : null}
        </Fragment>
    )
}
